/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type marketingWidgetQueryVariables = {
    readonly id: string;
};
export type marketingWidgetQueryResponse = {
    readonly list: {
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly list: ({
            readonly __typename: string;
            readonly items?: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly id?: string;
                            readonly label?: string | null;
                            readonly landingPageUrl?: string | null;
                            readonly files?: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                        } & ({
                            readonly __typename: "MediaAsset";
                            readonly id: string;
                            readonly label: string | null;
                            readonly landingPageUrl: string | null;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
            } | null;
        } & ({
            readonly __typename: "FixedList";
            readonly items: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly id?: string;
                            readonly label?: string | null;
                            readonly landingPageUrl?: string | null;
                            readonly files?: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                        } & ({
                            readonly __typename: "MediaAsset";
                            readonly id: string;
                            readonly label: string | null;
                            readonly landingPageUrl: string | null;
                            readonly files: ReadonlyArray<{
                                readonly id: string;
                                readonly name: string | null;
                                readonly path: string | null;
                            }> | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
            } | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type marketingWidgetQuery = {
    readonly response: marketingWidgetQueryResponse;
    readonly variables: marketingWidgetQueryVariables;
};



/*
query marketingWidgetQuery(
  $id: ID!
) {
  list(id: $id) {
    hasErrors
    errors {
      id
      location
    }
    list {
      __typename
      ... on FixedList {
        items {
          count
          edges {
            listItem {
              item {
                __typename
                ... on MediaAsset {
                  id
                  label
                  landingPageUrl
                  files {
                    id
                    name
                    path
                  }
                }
                ... on Node {
                  id
                }
                ... on SearchHit {
                  id
                }
                ... on Tag {
                  id
                }
              }
              id
            }
          }
        }
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "location",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "marketingWidgetQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "MediaAsset",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "marketingWidgetQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "MediaAsset",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "marketingWidgetQuery",
    "id": null,
    "text": "query marketingWidgetQuery(\n  $id: ID!\n) {\n  list(id: $id) {\n    hasErrors\n    errors {\n      id\n      location\n    }\n    list {\n      __typename\n      ... on FixedList {\n        items {\n          count\n          edges {\n            listItem {\n              item {\n                __typename\n                ... on MediaAsset {\n                  id\n                  label\n                  landingPageUrl\n                  files {\n                    id\n                    name\n                    path\n                  }\n                }\n                ... on Node {\n                  id\n                }\n                ... on SearchHit {\n                  id\n                }\n                ... on Tag {\n                  id\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '0c2a2178284ae5d9c23c7b82d2c3052e';
export default node;
